import { Immutable } from "immer";
import React from "react";
import { FinancingModalTrigger } from "tsi-common-react/src/apps/financing/FinancingModalTrigger";
import { Link } from "tsi-common-react/src/components/Link/index";
import { SrFootnote } from "tsi-common-react/src/components/SrFootnote/index";
import { getDefaultFinancingPlan } from "tsi-common-react/src/utils/financing";
import { formatFinancingPlan } from "tsi-common-react/src/utils/format";
import { usePageURL, useStaticURL } from "tsi-common-react/src/utils/urls";
import { c, t } from "ttag";

import styles from "./index.module.scss";

type IProps = Immutable<{
    applicationSource?: string;
}>;

export const FinancingBannerBlock = (props: IProps) => {
    const plan = formatFinancingPlan(getDefaultFinancingPlan());
    const financeLink = usePageURL("finance_link");
    const staticURL = useStaticURL();
    return (
        <section className={styles.root}>
            <div>
                <img
                    alt={t`Tempur-Pedic Credit Card`}
                    src={`${staticURL}img/finance/sealy-credit-card-high-res.png`}
                    loading="lazy"
                    decoding="async"
                />
                <div>
                    <h3>
                        {c("FinancingBannerBlock")
                            .t`${plan.apr} APR for ${plan.length} Months`}
                        <sup>
                            <Link href={financeLink}>
                                {plan.superscript}
                                <SrFootnote
                                    text={t`Additional information about Terms and Conditions`}
                                />
                            </Link>
                        </sup>
                    </h3>
                    <div>{t`with minimum purchase of ${plan.threshold}`}</div>
                    <ul>
                        {/* TODO(i18n): Use t tagged template: {t`No annual fee`} */}
                        <li>
                            No annual fee <sup>1</sup>
                        </li>
                        {/* TODO(i18n): Use t tagged template: {t`Pre-qualify without impacting your credit score`} */}
                        <li>Pre-qualify without impacting your credit score</li>
                        {/* TODO(i18n): Use t tagged template: {t`Apply now or during checkout`} */}
                        <li>Apply now or during checkout</li>
                    </ul>
                </div>
                <div>
                    <FinancingModalTrigger
                        modalType="prequal-app"
                        className="button button--primary-inverted"
                        applicationSource={props.applicationSource}
                    >
                        {t`Check if You Pre-Qualify`}
                    </FinancingModalTrigger>
                    <FinancingModalTrigger
                        modalType="full-app"
                        className="button button--white-outline"
                        applicationSource={props.applicationSource}
                    >
                        {t`Apply Now`}
                    </FinancingModalTrigger>
                </div>
            </div>
        </section>
    );
};
